import React from "react";
import Navbar from "./global-components/navbar-v3";
import PageHeader from "./global-components/page-header";
import PrivacyPolicy from "./section-components/privacy-policy";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const PrivacyPolicyPage = () => {
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Privacy Policy" />
      <PrivacyPolicy />
      <CallToActionV1 />
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
